import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useHeroImages } from '../hooks/useHeroImages';
export function Hero() {
  const {
    images,
    loading
  } = useHeroImages();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  useEffect(() => {
    if (images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);
  useEffect(() => {
    if (currentIndex >= images.length && images.length > 0) {
      setCurrentIndex(0);
    }
  }, [images.length, currentIndex]);
  const currentImage = images[currentIndex]?.url;
  const nextImage = images[(currentIndex + 1) % images.length]?.url;
  const handleContactClick = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  // Precargar siguiente imagen
  useEffect(() => {
    if (nextImage) {
      const img = new Image();
      img.src = nextImage;
    }
  }, [nextImage]);
  return <section className="relative min-h-[65vh] sm:min-h-[75vh] md:min-h-screen w-full overflow-hidden bg-gray-900" data-id="element-421">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-422">
        {currentImage ? <AnimatePresence mode="wait" data-id="element-423">
            <motion.div key={currentImage} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeInOut'
        }} className="absolute inset-0" data-id="element-424">
              <img src={currentImage} alt="Proyecto de construcción corporativa" className="h-full w-full object-cover" loading="eager" decoding="async" fetchpriority="high" onLoad={() => setImageLoaded(true)} style={{
            imageRendering: 'crisp-edges',
            willChange: 'transform'
          }} data-id="element-425" />
            </motion.div>
          </AnimatePresence> : <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-blue-900/50 to-gray-900" data-id="element-426">
            {!loading && <div className="absolute inset-0 flex items-center justify-center" data-id="element-427">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent" data-id="element-428"></div>
              </div>}
          </div>}

        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/60 to-transparent z-10" data-id="element-429" />
      </div>

      {/* Content */}
      <div className="relative z-20 flex min-h-[65vh] sm:min-h-[75vh] md:min-h-screen flex-col justify-center px-4 pt-28 pb-16 sm:px-6 sm:pt-36 sm:pb-20 lg:px-16" data-id="element-430">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-5xl" data-id="element-431">
          <span className="mb-6 inline-block rounded-full bg-blue-600/20 px-4 py-1.5 text-sm font-semibold text-blue-100 backdrop-blur-md border border-blue-500/30" data-id="element-432">
            Construcción Corporativa
          </span>

          <h1 className="mb-6 text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl leading-[1.1]" data-id="element-433">
            Construimos espacios que{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400" data-id="element-434">
              generan más negocios.
            </span>
          </h1>

          <p className="mb-8 sm:mb-10 text-lg sm:text-xl font-light text-gray-200 sm:text-2xl md:max-w-2xl leading-relaxed" data-id="element-435">
            Especialistas en habilitación de oficinas y retail. Transformamos
            metros cuadrados en experiencias productivas.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-436">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-4 text-lg font-bold text-white shadow-lg shadow-blue-600/30 hover:shadow-blue-600/50" onClick={handleContactClick} data-id="element-437">
              Conversemos tu proyecto
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-438" />
            </motion.button>

            <Link to="/proyectos" data-id="element-439">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-8 py-4 text-lg font-semibold text-white backdrop-blur-sm" data-id="element-440">
                Ver obras
              </motion.button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}